import { Link } from "react-router-dom";
import { TmaisUserData } from "../types/tmaisUsers.type";
import Button from "@/common/components/Button";
import { ArrowBigRight } from "lucide-react";
import { formatPhoneNumber } from "@/common/utils/formatters";

export class TmaisUsersTransformer {
  static tableTransformer() {
    return (tmaisUsers: TmaisUserData[]) => {
      return tmaisUsers.map((tmaisUser) => {
        return {
          ...tmaisUser,
          city: tmaisUser?.address?.city?.display_name ?? '--',
          phone: tmaisUser?.phone?.number ? formatPhoneNumber(tmaisUser?.phone?.number) : '--',
          action: (
            <Link to={tmaisUser.id}>
              <Button name="access_tmais_user_button" variant='link-white' className="w-full" operationKlassToCheckPermission="Admin::Tmais::Users::Show">
                <ArrowBigRight />
              </Button>
            </Link>
          )
        };
      });
    };
  }
}
